import React from 'react';
import { GoogleMap } from '@react-google-maps/api';
import { containerStyle, defaultCenter } from './constants';
import RepairFinderMarker from '../RepairFinderMarker';
import useGeoSearchMerchants from '../../resources/merchant/geoSearch';

const RepairFinderMap = ({
  map, setMap, selectedDealershipId, setSelectedDealershipId,
}) => {
  const {
    trigger: getDealerships,
    data: { data: dealershipMarkers = [] } = {},
  } = useGeoSearchMerchants();

  const handleOnIdle = () => {
    getDealerships({
      ne_lat: map.getBounds().getNorthEast().lat(),
      ne_lng: map.getBounds().getNorthEast().lng(),
      sw_lat: map.getBounds().getSouthWest().lat(),
      sw_lng: map.getBounds().getSouthWest().lng(),
      c_lat: map.getCenter().lat(),
      c_lng: map.getCenter().lng(),
      hide_non_partners: true,
    });
  };

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={defaultCenter}
      zoom={12}
      onLoad={(mapInstance) => setMap(mapInstance)}
      onUnmount={() => setMap(null)}
      onIdle={handleOnIdle}
      options={{ fullscreenControl: false }}
    >
      <>
        {dealershipMarkers.map((dealership) => (
          <RepairFinderMarker
            dealership={dealership}
            map={map}
            selectedDealershipId={selectedDealershipId}
            setSelectedDealershipId={setSelectedDealershipId}
            key={dealership.id}
          />
        ))}
      </>
    </GoogleMap>
  );
};

export default RepairFinderMap;
